import { Controller } from "@hotwired/stimulus"

const MAPPED_CLASS = "csv-mapping__mapped"
const LABEL_CLASS = "csv-mapping__label"

// Connects to data-controller="bank--csv-mapping"
// CSV column mapping page: highlights the sample columns the mapping selects currently read
// from and names the field under each header. Purely cosmetic — the server validates the
// mapping on submit.
export default class extends Controller {
  static targets = ["select", "header", "sample"]

  connect() {
    this.refresh()
  }

  refresh() {
    const fieldsByHeader = this.#fieldsByHeader()

    for (const header of this.headerTargets) {
      const fields = fieldsByHeader.get(header.dataset.header)
      const mapped = Boolean(fields)

      header.querySelector(`.${LABEL_CLASS}`)?.remove()
      header.classList.toggle(MAPPED_CLASS, mapped)
      for (const cell of this.#columnCells(header.cellIndex)) {
        cell.classList.toggle(MAPPED_CLASS, mapped)
      }

      if (mapped) {
        const label = document.createElement("span")
        label.className = `${LABEL_CLASS} badge badge--primary-light`
        label.textContent = fields.join(", ")
        header.append(label)
      }
    }
  }

  // Header name → labels of every field mapped to it (two fields may share one column).
  #fieldsByHeader() {
    const fieldsByHeader = new Map()
    for (const select of this.selectTargets) {
      if (!select.value) continue

      const fields = fieldsByHeader.get(select.value) || []
      fields.push(select.labels?.[0]?.textContent.trim() || select.name)
      fieldsByHeader.set(select.value, fields)
    }
    return fieldsByHeader
  }

  #columnCells(index) {
    if (!this.hasSampleTarget) return []

    return Array.from(this.sampleTarget.tBodies).flatMap((body) =>
      Array.from(body.rows)
        .map((row) => row.cells[index])
        .filter(Boolean)
    )
  }
}
